export default "__VITE_ASSET__J_m$EDko__"